import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as n, normalizeClass as d, createElementVNode as l } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconUnlink2",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ l("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.5 4a2 2 0 1 0 0 4h1a.5.5 0 0 1 0 1h-1a3 3 0 1 1 0-6h1a.5.5 0 0 1 0 1h-1ZM7 3.5a.5.5 0 0 1 .5-.5h1a3 3 0 1 1 0 6h-1a.5.5 0 0 1 0-1h1a2 2 0 1 0 0-4h-1a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  _
];
function u(e, m, i, f, p, a) {
  return n(), r("svg", {
    "aria-label": i.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--unlink-2"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Unlink 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, h, 10, c);
}
const k = /* @__PURE__ */ o(s, [["render", u]]);
export {
  k as default
};
//# sourceMappingURL=unlink-2.js.map
